import { Box, Typography } from "@mui/material";
import { NotificationListItem } from "./NotificationListItem";
import React from "react";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { UserNotification } from "@backend-types";
import { NotificationCategory } from "../../../interfaces";

const useStyles = makeStyles<Theme, NotificationListProps>((theme) => ({
  title: {
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: (props) => props.categoryFontSize,
  },
  actionButton: {
    color: theme.palette.text.secondary,
  },
}));

interface NotificationListProps {
  notificationCategory: NotificationCategory[];
  notifications: UserNotification[];
  categoryFontSize: string;
  showCategoryDivider?: boolean;
  noNotificationMessage?: string;
}

export const NotificationList = (props: NotificationListProps) => {
  const classes = useStyles(props);
  const {
    notificationCategory,
    notifications,
    showCategoryDivider = true,
    noNotificationMessage,
  } = props;
  return (
    <>
      {notifications.length === 0 && (
        <Box sx={{ marginTop: "16px" }}>
          <Typography sx={{ fontSize: "15px" }} variant="body2">
            {noNotificationMessage}
          </Typography>
        </Box>
      )}
      {notificationCategory.map((category, index) => {
        return (
          <Box key={index} sx={{ marginTop: "16px" }}>
            {notifications
              .filter(category.filter)
              .sort(
                (a, b) =>
                  new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
              )
              .map((notification, index) => {
                return (
                  <>
                    {index === 0 && (
                      <Typography variant="h6" className={classes.title}>
                        {category.name}
                      </Typography>
                    )}
                    <NotificationListItem
                      notificationCategory={category}
                      key={index}
                      notification={notification}
                    />
                  </>
                );
              })}
            {showCategoryDivider &&
              notifications.filter(category.filter).length > 0 &&
              index !== notificationCategory.length - 1 && (
                <Box sx={{ marginTop: "16px", marginBottom: "16px" }}>
                  <hr style={{ border: "1px solid #E2E2E2" }} />
                </Box>
              )}
          </Box>
        );
      })}
    </>
  );
};
